import { FC } from 'react';

import { usePageTitle } from 'hooks/usePageTitle';

import styles from './Card.module.scss';

import { useCardListStateModel } from 'components/pages/Card/model/useCardListStateModel';
import { CaredModalView } from 'components/pages/Card/sections/CardModalView';
import { CardReceiveDialogView } from 'components/pages/Card/sections/CardReceiveDialogView';
import { TopSection } from 'components/pages/Card/sections/TopSection';
import { CardListSection } from 'components/pages/Card/sections/CardListSection';
import { useCardListDataSource } from 'components/pages/Card/model/useCardListDataSource';
import { cx } from 'utils/cx';
import { Paragraph } from 'components/parts/Paragraph';

export const Card: FC = () => {
  usePageTitle('クリアカード');

  const { cardStatistics, areaCards, missionCards } = useCardListDataSource();

  const {
    tab,
    setTab,
    selectedCard,
    modalData,
    handleOpenModal,
    handleCloseModal,
    handleReceiveClick,
    handleCloseReceiveDialog,
  } = useCardListStateModel();

  const [numCompleted, numTotal] =
    tab === 'area'
      ? [cardStatistics.areasCompleted, cardStatistics.areasAll]
      : [cardStatistics.missionsCompleted, cardStatistics.missionsAll];

  return (
    <div className={cx(styles.wrapper, styles[`--${tab}`])}>
      <div className={styles.inner}>
        <TopSection numCompleted={numCompleted} numTotal={numTotal} tab={tab} setTab={setTab} />
        {tab === 'area' && (
          <div className={styles.text2}>
            <Paragraph>
              報告所で実物カードを受け取りたい方はスタッフが提示する二次元コードを読み込んでね。
            </Paragraph>
          </div>
        )}
        {tab === 'area' && (
          <CardListSection
            cardList={areaCards}
            handleOpenModal={handleOpenModal}
            handleReceiveClick={handleReceiveClick}
          />
        )}
        {tab === 'mission' && (
          <CardListSection
            cardList={missionCards}
            handleOpenModal={handleOpenModal}
            handleReceiveClick={handleReceiveClick}
          />
        )}
      </div>
      {modalData && <CaredModalView card={modalData} handleClose={handleCloseModal} />}
      {selectedCard && (
        <CardReceiveDialogView card={selectedCard} handleClose={handleCloseReceiveDialog} />
      )}
    </div>
  );
};
